import type { ServiceUnavailableTranslation } from './serviceUnavailable.translation.pl.ts';

export const serviceUnavailableTranslation: ServiceUnavailableTranslation = {
  message: "We're not accepting internship applications right now - see you in March",
};
